/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/plot'
export default icon
